import {
    EDIT_DEBIT_CARD_COMPLETED,
    EDITING_DEBIT_CARD,
    SELECT_REPAYMENT_ROLE,
    UPDATE_DEBIT_CARD_PENDING
} from './EditPaymentMethodModal.actions';
import { mergeStates } from '../../../iwProvider/StoreHelper';
import { deserializePaymentMethod } from '../../Profile/ProfileHelper';

type TInitialState = {
    ready: boolean;
    updatingDebitCard: boolean;
    cardNumber: string | null;
    expiryDateFormatted: string | null;
    brand: string | null;
    repaymentRole: string | null;
    paymentMethodID: string | null;
    fundingRole: string | null;
    type: string | null;
    isPrimary: boolean | null;
};

const initialState: TInitialState = {
    ready: false,
    updatingDebitCard: false,
    cardNumber: null,
    expiryDateFormatted: null,
    brand: null,
    repaymentRole: null,
    paymentMethodID: null,
    fundingRole: null,
    type: null,
    isPrimary: null
};

type TAction = {
    type?: string;
    repaymentRole?: string;
    paymentMethod?: string;
};

// eslint-disable-next-line import/no-default-export
export default function (
    state = mergeStates(initialState),
    action: TAction = {}
) {
    switch (action.type) {
        case UPDATE_DEBIT_CARD_PENDING:
            return mergeStates(state, {
                updatingDebitCard: true
            });

        case EDIT_DEBIT_CARD_COMPLETED:
            return mergeStates(state, {
                updatingDebitCard: false
            });

        case SELECT_REPAYMENT_ROLE:
            return mergeStates(state, {
                ...state,
                repaymentRole: action.repaymentRole
            });

        case EDITING_DEBIT_CARD:
            const paymentMethod = deserializePaymentMethod(
                action.paymentMethod
            );
            return mergeStates(state, {
                ...state,
                ...paymentMethod
            });

        default:
            return state;
    }
}
